import { useContext, useEffect, useState } from "react";
import {
  MdCall,
  MdEmail,
  MdLocationOn,
  MdOutlineAccessTime,
  MdWhatsapp,
} from "react-icons/md";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

export default function ContactUsContent({ showHeader = true }) {
  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const contactMethods = [
    {
      label: "Call",
      value: "+255 717 515 036",
      icon: <MdCall size={24} />,
      href: "tel:+255717515036",
    },
    {
      label: "Email",
      value: "info@esmeriser.com",
      icon: <MdEmail size={24} />,
      href: "mailto:info@esmeriser.com",
    },
    {
      label: "WhatsApp",
      value: "+255 717 515 036",
      icon: <MdWhatsapp size={24} />,
      href: "https://wa.me/255717515036",
    },
  ];

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  async function submitMessage(e) {
    e.preventDefault();

    if (!fullname || fullname.trim().length === 0) {
      appContext.tellError("Your name is required");
      return;
    }

    if (!email || email.trim().length === 0) {
      appContext.tellError("Your email is required");
      return;
    }

    if (!message || message.trim().length === 0) {
      appContext.tellError("Your message is required");
      return;
    }

    setLoading(true);
    await appContext.setShowOverlayLoader(true);
    await appContext
      .createContactMessage({
        fullname: fullname.trim(),
        email: email.trim(),
        message: message.trim(),
        details: message.trim(),
      })
      .then((response) => {
        if (response.status === 1) {
          setFullname("");
          setEmail("");
          setMessage("");
          appContext.tellMessage("Message sent successfully");
        } else {
          appContext.tellError(response.msg);
        }
      });
    setLoading(false);
    appContext.setShowOverlayLoader(false);
  }

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <section className="MainBodySection contact-page-section">
      <div className="container">
        {showHeader ? (
          <div className="contact-page-section-heading text-center">
            <p className="home-banner-kicker">Reach Us</p>
            <h2 className="home-service-title font-bold">Contact Us</h2>
          </div>
        ) : null}

        <div className="contact-page-methods" data-aos="fade-up">
          {contactMethods.map((method) => (
            <a className="contact-page-method" href={method.href} key={method.label}>
              <span className="contact-page-method-icon">{method.icon}</span>
              <span>
                <strong>{method.label}</strong>
                <small>{method.value}</small>
              </span>
            </a>
          ))}
        </div>

        <div className="contact-page-body">
          <div className="contact-page-info" data-aos="fade-right">
            <p className="home-banner-kicker">Visit or Message</p>
            <h2 className="font-bold">We Are Ready for Your Brand Story.</h2>
            <p>
              Whether it is a single product, a campaign set, packaging, or
              signage, share the goal and we will guide the print and branding
              direction.
            </p>

            <div className="contact-page-detail-list">
              <div className="contact-page-detail">
                <MdLocationOn size={22} />
                <div>
                  <strong>Location</strong>
                  <span>Dar es salaam, Mbuyuni, near Namanga, Manara Street, Gate No. 32</span>
                </div>
              </div>

              <div className="contact-page-detail">
                <MdOutlineAccessTime size={22} />
                <div>
                  <strong>Response Time</strong>
                  <span>We respond during business hours.</span>
                </div>
              </div>
            </div>

            <div className="contact-page-note">
              Bring your logo, idea, color direction, or product sample. We can
              help refine the output from there.
            </div>
          </div>

          <div className="contact-page-form-card" data-aos="fade-left">
            <div className="contact-page-form-head">
              <p className="home-banner-kicker">Project Inquiry</p>
              <h3 className="font-bold">Tell Us What You Need</h3>
            </div>

            <form onSubmit={submitMessage}>
              <label htmlFor="contact-name">Your Name</label>
              <input
                id="contact-name"
                type="text"
                placeholder="Enter your full name"
                className="form-control"
                value={fullname}
                onChange={(e) => setFullname(e.target.value)}
              />

              <label htmlFor="contact-email">Email Address</label>
              <input
                id="contact-email"
                type="email"
                placeholder="Enter your email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <label htmlFor="contact-message">Project Details</label>
              <textarea
                id="contact-message"
                placeholder="Tell us about the product, quantity, timeline, and any branding ideas."
                className="form-control"
                rows={5}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <button className="contact-page-submit" type="submit">
                {loading ? "Sending..." : "Send Inquiry"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
